module.exports = __webpack_public_path__ + "img/construction-regular.8115dcd0.svg";